import { instance } from "./instance";
import { ICarDetail, ICatalog, IHit, IUser } from "../types";


const api = {
    searchProduct(vin: string) {
        return instance.get(`/search/details?vin_number=${vin}`).then((res) => {
            return res.data;
        })
    },
    userLogin(user: IUser) {
        return instance.post('login', user).then((res) => res.data)
    },
    userRegistration(user: IUser) {
        return instance.post('users', user).then((res) => res.data)
    },
    createModel(newModel: any) {
        return instance.post('models', newModel).then((res) => res)
    },
    getCars() {
        return instance.get('cars').then((res) => res.data)
    },
    getCarModels() {
        return instance.get('carModels').then((res) => res.data)
    },
    getCarGenerations() {
        return instance.get('generations').then((res) => res.data)
    },
    getCarBodies() {
        return instance.get('bodies').then((res) => res.data)
    },
    getCarEngines() {
        return instance.get('engines').then((res) => res.data)
    },
    getAllDetails() {
        return instance.get('details').then((res) => res.data)
    },
    getAllCatalogs() {
        return instance.get('catalogs').then((res) => res.data)
    },
    getAllHits() {
        return instance.get('hitProducts').then((res) => res.data)
    }, getHit(id?: string) {
        return instance.get('hitProducts/' + id).then((res) => res.data)
    },
    getCar(id: any) {
        return instance.get(`cars/${id}/carModels`).then((res) => res.data)
    },
    getModel(id: any) {
        return instance.get(`cars/carModels/${id}/generations`).then((res) => res.data)
    },
    getGenerations(id: any) {
        return instance.get(`cars/carModels/generations/${id}/bodies`).then((res) => res.data)
    },
    getBodies(id: any) {
        return instance.get(`cars/carModels/generations/bodies/${id}/engines`).then((res) => res.data)
    },
    getEngine(id: any) {
        return instance.get(`cars/carModels/generations/bodies/${id}/engines`).then((res) => res.data)
    },
    getCarDetail(id: any) {
        return instance.get(`cars/carModels/generations/bodies/engines/${id}/details`).then((res) => res.data)
    },
    getCatalogType(catalog_type: string) {
        return instance.get('catalogType?catalog_name=' + catalog_type).then((res) => res.data)
    },
    deleteHitProduct(id: number) {
        return instance.delete('hitProduct/' + id).then(res => res.data)
    },
    addHitProduct(catalogs_id: string, hitProduct: IHit) {
        return instance.post('hitProduct/' + catalogs_id, hitProduct).then(res => res.data)
    },
    deleteCarDetail(id: number) {
        return instance.delete('details/' + id).then(res => res.data)
    },
    deleteCarModel(id: number) {
        return instance.delete('carModels/' + id).then(res => res.data)
    },
    deleteCarGeneration(id: number) {
        return instance.delete('generations/' + id).then(res => res.data)
    },
    deleteCarEngine(id: number) {
        return instance.delete('engines/' + id).then(res => res.data)
    },
    deleteCarBody(id: number) {
        return instance.delete('bodies/' + id).then(res => res.data)
    },
    deleteCatalog(id: number) {
        return instance.delete('/catalogs/' + id).then(res => res.data)
    },
    addCatalog(newCatalog: any) {
        return instance.post('/catalogs/', newCatalog, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(res => res.data)
    },
    addNewDetail(newDetail: any, engineId?: number) {
        return instance.post('details/' + engineId + "/engines", newDetail, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(res => res)
    },
    addCatalogType(newCatalogType: string) {
        return instance.post('catalogType', { catalogName: newCatalogType }).then(res => res.data)
    },
    allCatalogTypes() {
        return instance.get("catalogType?catalog_name=All").then(res => res.data)
    },
    deleteCatalogType(catalog_name: string) {
        return instance.delete("catalogType?catalog_name=" + catalog_name).then(res => res.data)
    },
    editCatalog(catalog: ICatalog, id: number) {
        return instance.put('catalogs/' + id, catalog).then(res => res.data)
    }
};

export default api;
